if (typeof customElements.get("wdn-subscription-toggle") === "undefined") {
  class WDNSubscriptionToggle extends HTMLElement {
    connectedCallback() {
      var self = this;

      this.segments = this.querySelectorAll("[data-toggle-value]");
      this.subscribeSegment = this.querySelector('[data-toggle-value="subscribe"]');
      this.frequencyWrapper = this.querySelector("[data-frequency-wrapper]");
      this.frequencyDropdown = this.querySelector("[data-frequency-dropdown]");
      this.frequencyTriggerLabel = this.querySelector("[data-frequency-trigger-label]");
      this.frequencyOptions = this.querySelectorAll("[data-frequency-option]");
      this.sellingPlanInput = this.querySelector("[data-selling-plan-input]");
      this.onetimePriceTag = this.querySelector("[data-onetime-price-tag]");
      this.subscribePriceTag = this.querySelector("[data-subscribe-price-tag]");
      this.subscriptionInfo = this.querySelector("[data-subscription-info]");
      this.summarySentence = this.querySelector("[data-summary-display]");
      this.badgeChip = this.querySelector("[data-badge-chip]");

      this.onetimePriceCents = parseFloat(this.dataset.onetimePriceCents);
      this.onetimeComparePriceCents = parseFloat(this.dataset.onetimeComparePriceCents);

      this.segments.forEach(function (btn) {
        btn.addEventListener("click", function () {
          self.setMode(btn.getAttribute("data-toggle-value"));
        });
      });

      this.frequencyOptions.forEach(function (btn) {
        btn.addEventListener("click", function () {
          self.selectFrequencyOption(btn);
        });
      });

      // Switching the underlying variant (size/color) may change or remove the
      // available selling plan, so fall back to one-time purchase on any variant change.
      document.querySelectorAll('input[name="variant_selection"]').forEach(function (input) {
        input.addEventListener("click", function () {
          self.setMode("onetime");
          if (self.onetimePriceTag) {
            self.onetimePriceTag.setAttribute("data-price-cents", input.dataset.linePrice);
            self.onetimePriceTag.setAttribute("data-compare-price-cents", input.dataset.lineComparePrice);
          }
        });
      });
    }

    setMode(mode) {
      this.segments.forEach(function (btn) {
        var active = btn.getAttribute("data-toggle-value") === mode;
        var box = btn.closest(".subscription-toggle__segment");
        if (box) box.classList.toggle("is-active", active);
        btn.setAttribute("aria-pressed", active);
      });

      if (mode === "subscribe") {
        if (this.frequencyWrapper) this.frequencyWrapper.hidden = false;
        if (this.subscriptionInfo) this.subscriptionInfo.hidden = false;
        var selectedOption = this.querySelector("[data-frequency-option].is-selected");
        this.applyOption(selectedOption || this.subscribeSegment);
      } else {
        if (this.frequencyWrapper) this.frequencyWrapper.hidden = true;
        if (this.subscriptionInfo) this.subscriptionInfo.hidden = true;
        this.sellingPlanInput.disabled = true;
        ProductPage.prices.update(this.onetimePriceCents, this.onetimeComparePriceCents);
      }
    }

    selectFrequencyOption(btn) {
      this.frequencyOptions.forEach(function (b) {
        b.classList.toggle("is-selected", b === btn);
      });

      if (this.frequencyTriggerLabel) this.frequencyTriggerLabel.textContent = btn.dataset.label;

      this.applyOption(btn);

      if (this.frequencyDropdown && this.frequencyDropdown.setInactive) {
        this.frequencyDropdown.setInactive();
      }
    }

    applyOption(el) {
      if (!el) return;
      var data = el.dataset;

      this.sellingPlanInput.value = data.sellingPlanId;
      this.sellingPlanInput.disabled = false;

      ProductPage.prices.update(parseFloat(data.priceCents), parseFloat(data.comparePriceCents));

      if (this.subscribePriceTag) {
        this.subscribePriceTag.setAttribute("data-price-cents", data.priceCents);
        this.subscribePriceTag.setAttribute("data-compare-price-cents", data.comparePriceCents);
      }

      if (this.summarySentence) this.summarySentence.innerHTML = data.summarySentence;
      if (this.badgeChip && data.badgeLabel) this.badgeChip.textContent = data.badgeLabel;
    }
  }

  customElements.define("wdn-subscription-toggle", WDNSubscriptionToggle);
}
